import { debug, Parser, type JSONDataWithMeta } from "@monade/json-api-parser";

type PaginationMeta = {
  currentPage?: number;
  totalPages?: number;
  totalRows?: number;
  totalCount?: number;
  [key: string]: unknown;
};

const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export interface JSONAPIQuery {
  include?: string;
  [key: `fields[${string}]`]: string | undefined;
}

export interface JSONAPIListFilters extends JSONAPIQuery {
  [key: `filter[${string}]`]: string | number | string[] | undefined;
}

export interface JSONAPIListQuery extends JSONAPIListFilters {
  'page[number]'?: string | number;
  'page[size]'?: string | number;
  sort?: string;
}

export type Response = JSONDataWithMeta<PaginationMeta>

export function parseJSON<T>(e: Response) {
  return new Parser(e.data, e.included).run<T>() as T
}

export function parseListWithMeta<T>(e: Response) {
  const list = new Parser(e.data, e.included).run<T[]>() as T[];
  const meta = e.meta;

  return { list, meta };
}

export function configureParser() {
  const IGNORED_KEYS = ['Symbol(', '_', '$', '#'];
  debug.adapter = (level: string, message: string, metadata: unknown) => {
    if (level !== 'error') {
      return;
    }
    if (!isObjectRecord(metadata)) {
      return;
    }

    const type = typeof metadata.type === 'string' ? metadata.type : undefined;
    const property =
      typeof metadata.property === 'string' ? metadata.property : undefined;

    if (type !== 'ACCESSING_NOT_INCLUDED_MODEL') {
      return;
    }
    if (!property) {
      return;
    }
    if (IGNORED_KEYS.some((key) => property.includes(key))) {
      return;
    }
    
    console.error(message, metadata);
  };
}